module.exports = __webpack_public_path__ + "img/mssss.41fb0065.png";